"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _invariant = _interopRequireDefault(require("invariant"));

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _eventSourcePolyfill = require("event-source-polyfill");

var _sanitizeData = _interopRequireDefault(require("../utils/sanitizeData"));

var _sanitizeUrl = _interopRequireDefault(require("../utils/sanitizeUrl"));

var _replaceRouteParams = _interopRequireDefault(require("../utils/replaceRouteParams"));

var _clientClass = _interopRequireDefault(require("./clientClass"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

_axios.default.defaults.withCredentials = true;

function resultData(_x) {
  return _resultData.apply(this, arguments);
}

function _resultData() {
  _resultData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(result) {
    var _yield$result, data;

    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return result;

          case 2:
            _yield$result = _context8.sent;
            data = _yield$result.data;
            return _context8.abrupt("return", data ? (0, _sanitizeData.default)(data) : data);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _resultData.apply(this, arguments);
}

function buildUrlString(serviceName, params) {
  var isRaw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return isRaw ? [(0, _sanitizeUrl.default)(serviceName)] : (0, _replaceRouteParams.default)(serviceName, params);
}

var normalizePath = function normalizePath(rex, replaceWith, pathCandidate) {
  return rex.test(pathCandidate) ? pathCandidate.replace(rex, replaceWith) : pathCandidate;
};

var RestClientClass = /*#__PURE__*/function (_ClientClass) {
  (0, _inherits2.default)(RestClientClass, _ClientClass);

  var _super = _createSuper(RestClientClass);

  function RestClientClass(_options) {
    var _this;

    (0, _classCallCheck2.default)(this, RestClientClass);
    _this = _super.call(this, _options);
    _this.connect = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var eventSourceUrl, EventSource;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.app = _axios.default.create({
                baseURL: _this.hostUri,
                timeout: 5000,
                paramsSerializer: function paramsSerializer(params) {
                  return _qs.default.stringify(params);
                }
              });
              eventSourceUrl = "".concat(_this.hostUri).concat(_this.eventSourceService); // Use only polyfill to send custom headers...

              EventSource = _eventSourcePolyfill.NativeEventSource || _eventSourcePolyfill.EventSourcePolyfill;

              if (!_this.realtime) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return _this.app.get('/ping', {
                headers: {
                  'x-sx-client-id': _this.secureClientId
                }
              });

            case 6:
              _this.eventSource = new EventSource(eventSourceUrl, {
                withCredentials: true,
                headers: {
                  'x-sx-client-id': _this.secureClientId
                }
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.callOptions = function (cfg, params) {
      var token = _this.getAccessTokenSync();

      var m = function m(d) {
        return function (t) {
          return (0, _lodash.default)(t, d);
        };
      };

      var pipe = function pipe() {
        for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
          fns[_key] = arguments[_key];
        }

        return function (x) {
          return fns.reduce(function (v, f) {
            return f(v);
          }, x);
        };
      };

      var options = pipe(m(_this.globalCallOptions), m({
        headers: {
          'x-sx-client-id': _this.secureClientId
        }
      }), m(cfg || {}), m(token ? {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      } : {}), m(params ? {
        params: params
      } : {}))({});
      return options;
    };

    _this.call = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(serviceName, data, cfg) {
        var _method$isRawUrl$cfg, isRawUrl, method, otherCfg, _buildUrlString, _buildUrlString2, fUrl, nextData, map;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _method$isRawUrl$cfg = (0, _extends2.default)({
                  method: 'get',
                  isRawUrl: false
                }, cfg), isRawUrl = _method$isRawUrl$cfg.isRawUrl, method = _method$isRawUrl$cfg.method, otherCfg = (0, _objectWithoutProperties2.default)(_method$isRawUrl$cfg, ["isRawUrl", "method"]);
                (0, _invariant.default)(method, 'RestClient.call requires method.');
                (0, _invariant.default)(serviceName && typeof serviceName === 'string', 'RestClient.call requires serviceName.');
                _buildUrlString = buildUrlString(serviceName, data, isRawUrl), _buildUrlString2 = (0, _slicedToArray2.default)(_buildUrlString, 2), fUrl = _buildUrlString2[0], nextData = _buildUrlString2[1];
                map = {
                  get: function get(u, d, c) {
                    return _this.app.get(u, _this.callOptions(c, d));
                  },
                  delete: function _delete(u, d, c) {
                    return _this.app.delete(u, _this.callOptions(c, d));
                  },
                  post: function post(u, d, c) {
                    return _this.app.post(u, d, _this.callOptions(c, {}));
                  },
                  put: function put(u, d, c) {
                    return _this.app.put(u, d, _this.callOptions(c, {}));
                  },
                  patch: function patch(u, d, c) {
                    return _this.app.patch(u, d, _this.callOptions(c, {}));
                  }
                };
                return _context2.abrupt("return", resultData((map[method] || map.get)(fUrl, nextData, otherCfg)));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.list = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(serviceName, params, cfg) {
        var path;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                (0, _invariant.default)(serviceName && typeof serviceName === 'string', 'RestClient.list requires serviceName.');
                path = normalizePath(/(\/|\.)list$/i, '', serviceName);
                return _context3.abrupt("return", _this.call(path, params, (0, _extends2.default)({}, cfg, {
                  method: 'get'
                })));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.get = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(serviceName, idOrData, cfg) {
        var id, path;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                (0, _invariant.default)(serviceName && typeof serviceName === 'string', 'RestClient.get requires serviceName.');
                (0, _invariant.default)(typeof idOrData === 'string' || typeof idOrData === 'number' || idOrData[_this.idField], "RestClient: get identifier is not valid ID or object that doesn't contain ID field ".concat(_this.idField));
                id = typeof idOrData === 'string' || typeof idOrData === 'number' ? idOrData : idOrData[_this.idField];
                path = normalizePath(/(\/|\.)get$/i, ".:".concat(_this.idField), serviceName);
                return _context4.abrupt("return", _this.call(path, {
                  id: id
                }, cfg));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x8, _x9, _x10) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.create = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(serviceName, data, cfg) {
        var path;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                (0, _invariant.default)(serviceName && typeof serviceName === 'string', 'RestClient.create requires serviceName.');
                path = normalizePath(/(\/|\.)create$/i, '', serviceName);
                return _context5.abrupt("return", _this.call(path, data, (0, _extends2.default)({
                  method: 'post'
                }, cfg)));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x11, _x12, _x13) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.update = /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(serviceName, data, cfg) {
        var path;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                (0, _invariant.default)(serviceName && typeof serviceName === 'string', 'RestClient.update requires serviceName.');
                (0, _invariant.default)(data[_this.idField], "RestClient: entity to update doesn't contain ID field ".concat(_this.idField));
                path = normalizePath(/(\/|\.)update$/i, ".:".concat(_this.idField), serviceName);
                return _context6.abrupt("return", _this.call(path, data, (0, _extends2.default)({
                  method: 'put'
                }, cfg)));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x14, _x15, _x16) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.remove = /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(serviceName, idOrData, cfg) {
        var id, path;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                (0, _invariant.default)(serviceName && typeof serviceName === 'string', 'RestClient.remove requires serviceName.');
                (0, _invariant.default)(typeof idOrData === 'string' || typeof idOrData === 'number' || idOrData[_this.idField], "RestClient: remove identifier is not valid ID or object that doesn't contain ID field ".concat(_this.idField));
                id = typeof idOrData === 'string' || typeof idOrData === 'number' ? idOrData : idOrData[_this.idField];
                path = normalizePath(/(\/|\.)remove$/i, ".:".concat(_this.idField), serviceName);
                return _context7.abrupt("return", _this.call(path, {
                  id: id
                }, (0, _extends2.default)({
                  method: 'delete'
                }, cfg)));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x17, _x18, _x19) {
        return _ref7.apply(this, arguments);
      };
    }();

    _this.addEventListener = function (eventName, cb) {
      if (_this.eventSource) _this.eventSource.addEventListener(eventName, cb);
    };

    _this.removeEventListener = function (eventName, cb) {
      if (_this.eventSource) _this.eventSource.removeEventListener(eventName, cb);
    };

    _this.userService = _options.userService || 'users';
    _this.eventSourceService = _options.eventSourceService || '_event-stream';
    _this.realtime = !!_options.realtime;
    return _this;
  }

  return RestClientClass;
}(_clientClass.default);

exports.default = RestClientClass;